export default function About() {
  const features = [
    {
      title: 'Mecanizado de Precisión',
      description: 'Tecnología avanzada para trabajos de mecanizado con tolerancias mínimas',
      icon: 'ri-settings-3-line',
    },
    {
      title: 'Equilibrado Industrial',
      description: 'Servicios especializados de equilibrado para componentes rotativos',
      icon: 'ri-scales-line',
    },
    {
      title: 'Enderezado',
      description: 'Corrección de deformaciones en piezas industriales de gran tamaño',
      icon: 'ri-ruler-line',
    },
    {
      title: 'Pulido Industrial',
      description: 'Acabados superficiales de alta calidad para todo tipo de materiales',
      icon: 'ri-contrast-drop-line',
    },
    {
      title: 'Construcción Mecánica',
      description: 'Diseño y fabricación de estructuras y componentes mecánicos complejos',
      icon: 'ri-tools-line',
    },
    {
      title: 'Flexibilidad en Plazos',
      description: 'Adaptación a las necesidades de entrega de cada cliente',
      icon: 'ri-time-line',
    },
  ];

  return (
    <section id="sobre-nosotros" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Sobre Nosotros
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Con casi medio siglo de historia, <strong>Talleres Lujambio</strong> es referencia en el sector industrial. Una empresa puntera e innovadora con un saber hacer cimentado sobre los valores humanos y el trabajo en equipo.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Con una flexibilidad notoria en los plazos de entrega y en la calidad del servicio, en nuestra trayectoria hemos trabajado para diferentes clientes de renombre y hemos destacado por nuestra profesionalidad y gran calidad.
            </p>
            <div className="flex items-start space-x-4 bg-teal-50 p-6 rounded-lg">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-map-pin-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 mb-1">Ubicación</h3>
                <p className="text-gray-700">
                  Polígono Industrial Eziago 35, Parcela 16<br />
                  Hernani, Gipuzkoa 20120
                </p>
              </div>
            </div>
          </div>

          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/b2605b3f474118a026af42c28638997f.jpg"
              alt="Instalaciones Talleres Lujambio"
              className="w-full h-full rounded-lg shadow-lg object-cover"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex items-start space-x-4 p-6 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-sm text-gray-600">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
